export default __webpack_public_path__ + "static/Cuboid-1-d5bf0f92e5db59af0bd3b2cd1c320f65.jpg";